import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FreeToolsFAQs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatAreLimits.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatAreLimits.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.emailIntegration.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.emailIntegration.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.howManyContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.howManyContacts.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatSupport.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatDiscounts.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whenEligibleForNewPricing.answer"
      })
    })]
  });
};